import {
  styled,
  rem
} from 'config/stitches.config'

import SimpleLink from '@/UI/Link'


export const StyledMenuItemLink = styled(SimpleLink, {
  transition: 'color ease-in-out .4s',
  variants: {
    highlighted: { true: { color: '$primary !important' } },
    current: {
      true: { color: '$darkGray' },
      false: { color: '$black', }
    }
  },
  compoundVariants: [
    {
      current: false,
      css: {
        '@md': {
          '&:hover': {
            '&::before': { transform: 'translateX(0%)' },
            'span': { transform: 'translateX(72px)' }
          }
        }
      }
    }
  ]
})

export const StyledMenuList = styled('ul', {
  margin: 0,
  padding: 0,
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '$2',

  'li': { display: 'inline-block' }
})


export const StyledMenuHeader = styled('nav', {
  marginBottom: rem(32),
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  scrollBehavior: 'smooth',


})

export const StyledMenuHeaderLi = styled('li', {
  [`${StyledMenuItemLink}`]: {
    overflow: 'hidden',
    position: 'relative',
    textDecoration: 'none',
    fontWeight: '$1',

    'span': { transition: 'transform 0.4s cubic-bezier(0.84, 0.03, 0.21, 0.99) 0s', },

    '&::before': {
      content: '',
      position: 'absolute',
      left: 0,
      top: '50%',
      width: rem(48),
      height: rem(4),
      backgroundColor: '$secondary',
      transition: 'transform 0.4s cubic-bezier(0.84, 0.03, 0.21, 0.99) 0s',
      transform: 'translateX(-100%)'
    },
  },
  variants: {
    idx: {
      0: {
        'a': {
          color: '$black',
          fontSize: '$h3-mobile',
          lineHeight: '$h3-mobile',
        }
      },
      1: {
        'a': {
          color: '$gray1',
          fontSize: '$h4-mobile',
          lineHeight: '$h4-mobile',
        }
      },
    },
    separator: { true: { marginTop: 40 } }
  }
})
